import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import './EditedStageArea.css'

const useStyles = makeStyles({
    statusSwitch:{
        float:"left",
        width:500,
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderRadius:5,
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#a1c2da",
        textAlign:"center",
        fontSize:20,
        lineHeight:"40px",
        margin:5,
        display:"flex",
        
    },
});
  

export default function EditedStageArea(props) {
    const classes = useStyles();
    let statusStageEdit = {
        backgroundColor:"#f8ff33",
        color:"#000000"
    }

    return (
        <div className={classes.statusSwitch}>
            <div className={"stageButton"} style={props.editingStage === 1 ?statusStageEdit : null} onClick={()=>{props.changeEditingStage(1)}}>
                階段I   標題
            </div>
            <div>&#9654;</div>
            <div>&#9654;</div>
            <div>&#9654;</div>
            <div className={"stageButton"} style={props.editingStage === 2 ?statusStageEdit : null} onClick={()=>{props.changeEditingStage(2)}}>
                階段II   內容
            </div>
            <div>&#9654;</div>
            <div>&#9654;</div>
            <div>&#9654;</div>
            <div></div>
            <div className={"stageButton"}  onClick={()=>{props.changeEditingStage(3)}}>
                最後設定
            </div>
        </div>
    )
}